<div class="backgroudColor">
  <img src="/assets/images/404.svg" alt="image" />
  <div class="text_center">
    <h4>Page introuvable</h4>
  </div>
</div>